module.exports = __webpack_public_path__ + "static/img/torso20.56341351.jpg";